var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsentContent',{attrs:{"consents":_vm.consentList},on:{"accepted":_vm.onAccepted}})
}
var staticRenderFns = []

export { render, staticRenderFns }